import { useQueryClient } from '@tanstack/react-query';
import * as React from 'react';

import { getChatHistory } from '../api/chat-history';

export const useInitialHistoryLoader = (
  leadId: string | undefined,
  isOpen: boolean,
  currentSource: string
) => {
  const queryClient = useQueryClient();
  const hasFetchedOnThisOpenRef = React.useRef<boolean>(false);

  const [hasShownInitialLoader, setHasShownInitialLoader] =
    React.useState(false);

  const [isInitialLoading, setIsInitialLoading] = React.useState(false);

  // Show loader when opening first time
  React.useEffect(() => {
    if (leadId && isOpen && !hasShownInitialLoader) {
      setIsInitialLoading(true);
    }
  }, [leadId, isOpen, hasShownInitialLoader]);

  // Fetch interaction-history exactly once per open
  React.useEffect(() => {
    if (leadId && isOpen && !hasFetchedOnThisOpenRef.current) {
      hasFetchedOnThisOpenRef.current = true;
      const queryKey = [
        'bhanzu-buddy',
        'chat-history',
        'get',
        { lead_id: leadId, source: currentSource },
      ] as const;
      void queryClient
        .fetchQuery({
          queryKey,
          queryFn: () =>
            getChatHistory({ lead_id: leadId, source: currentSource }),
        })
        .finally(() => {
          if (!hasShownInitialLoader) {
            setIsInitialLoading(false);
            setHasShownInitialLoader(true);
          }
        });
    }
    if (!isOpen) {
      hasFetchedOnThisOpenRef.current = false;
    }
  }, [isOpen, leadId, currentSource, queryClient, hasShownInitialLoader]);

  return { isInitialLoading } as const;
};
